import video from 'url:./images/video-1.mp4';
import videoMobile from 'url:./images/video-2.mp4';

import './js/app';